// extracted by mini-css-extract-plugin
export default {"itemHeader":"rss-feed_itemHeader__z8Tkt","rssIcon":"rss-feed_rssIcon__crZv7","rssData":"rss-feed_rssData__oSSB+","dotw":"rss-feed_dotw__O84Kz"};